module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-up-teal-ec18a948bbd629ee1e78c2e6d8a2398e.svg";